// extracted by mini-css-extract-plugin
module.exports = {"OptionTag":"styles_OptionTag__W38dF","label":"styles_label__HC0aj","closeIcon":"styles_closeIcon__GlJrH"};